<!--
/*******************************************************************************
*@ 컴포넌트명   : napasManagePayees.vue
*@ 컴포넌트설명 : 자주쓰는계좌등록 베트남 부분 (CITAD, NAPAS)
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2022.04.28           CITAD일 때 수취인명 필수로 수정
** 2023.05.16   이가영   (베트남) CITAD 수취인 유효성 검사 변경
********************************************************************************/
-->
<template>
  <section class="common">
    <div class="scroll">
      <article class="contents">
        <radio-box
          id="recvDstCd"
          :data-list="recvDstCd"
          :value.sync="recvCardAcc"
          default-checked-value="2"
          :is-horizontal="true"
          v-if="$route.params.type != 'manage' && !citadBnkYn"
        />
        <div class="form">
          <div class="form-row" v-if="recvCardAcc == '2'">
            <div class="item-tit">
              {{ /*은행명*/ $t("MPRS-02-02-02-05") }}
              <sup class="point">*</sup>
            </div>
            <div class="item-desc">
              <div class="form-text-field search">
                <div class="input-text-field column-mq">
                  <input type="text" id="textfield1" class="form-control" :value.sync="napasBnkName" disabled placeholder />
                  <button class="btn sm inline search" @click="openPopup()">{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- v-if로 했을 때 필수가 아닌데 필수표시가 남아있어서 v-show로 변경 -->
          <div v-show="citadBnkYn === true && recvCardAcc == '2'">
            <div class="form-row">
              <input-text ref="lcalBnkBrnEngName" id="lcalBnkBrnEngName" :value.sync="lcalBnkBrnEngName" labelI18n="MPRS-02-02-02-06" placeholder="MPRS-02-02-02-06" localeCase3 />
            </div>
            <!-- 통화코드 -->
            <div class="form-row">
              <select-box
                ref="selectedCncycd"
                :value.sync="citadCncycd"
                required
                :option-list="optionList"
                label-i18n="MINQ-01-01-06-08"
                :disabled="$route.params.type != 'manage'"
                @selected="validPrgs"
              />
            </div>
          </div>
          <template v-if="recvCardAcc == '2'">
            <div class="form-row">
              <input-text ref="inquryAcno" id="inquryAcno" :value.sync="inquryAcno" labelI18n="MPRS-02-02-09-04" placeholder="MPRS-02-02-09-04" required engCase2 :maxByte="20" />
              <div class="info info-etc-col" v-show="napasBnkNo != '' && !citadBnkYn">
                <p class="color-point" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })">
                  <!-- 입금계좌번호의 통화는 VND만 가능합니다. -->
                </p>
              </div>
            </div>
            <div class="form-row" v-show="$route.params.type == 'manage'">
              <input-text
                ref="inquryAcnAls"
                id="inquryAcnAls"
                :value.sync="inquryAcnAls"
                labelI18n="MPRS-02-02-19-07"
                placeholder="MPRS-02-02-09-08"
                required
                :maxByte="40"
                engCase6
              />
              <div class="info info-etc-col" v-show="citadBnkYn == false">
                <p>{{ $t(/*※ 계좌별명은 영문기준 최대 12자리까지 입력 가능합니다.*/ "MPRS-02-02-15-14") }}</p>
              </div>
            </div>
            <div class="form-row" v-if="citadBnkYn">
              <input-text
                ref="dpstrName"
                id="dpstrName"
                :value.sync="mnrcvDpstrNameData"
                labelI18n="MPRS-02-02-19-05"
                placeholder="MPRS-02-02-19-06"
                required
                :maxByte="40"
                engCase3
              />
            </div>
          </template>
          <template v-else>
            <div class="form-row">
              <div class="item-tit">
                {{ $t(/*카드번호*/ "MPAY-02-01-18-03") }}
                <sup class="point">*</sup>
              </div>
              <div class="item-desc">
                <div class="form-text-field">
                  <div class="input-text-field space-between group">
                    <input ref="card1" type="tel" id="card1" maxlength="4" class="form-control" v-model="card1" @keyup="autoFocus1" placeholder value />
                    <span class="hyphen">-</span>
                    <input ref="card2" type="tel" id="card2" maxlength="4" class="form-control" v-model="card2" @keyup="autoFocus2" placeholder value />
                    <span class="hyphen">-</span>
                    <input ref="card3" type="tel" id="card3" maxlength="4" class="form-control" v-model="card3" @keyup="autoFocus3" placeholder value />
                    <span class="hyphen">-</span>
                    <input ref="card4" type="tel" id="card4" maxlength="4" class="form-control" v-model="card4" placeholder value />
                  </div>
                </div>
                <div class="info info-etc-col" v-show="citadBnkYn == false">
                  <p class="color-point" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })">
                    <!-- 입금계좌번호의 통화는 VND만 가능합니다. -->
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </article>
    </div>
    <action-sheet :opened.sync="type1" :actionHeader="true" :actionFooter="true" :useTopBorder="true" title="지점 확인" class="action-sheet">
      <template #content>
        <div class="form-confirm">
          <div class="form-row">
            <div class="item-tit">{{ $t(/*입금 계좌번호*/ "MPAY-02-01-24-04") }}</div>
            <div class="item-desc">
              <div class="form-text-field">9834349348394y38497934</div>
            </div>
          </div>
          <div class="form-row">
            <div class="item-tit">지점 번호</div>
            <div class="item-desc">
              <div class="form-text-field">ererr</div>
            </div>
          </div>
          <!-- 2021-10-26 인도 추가 -->
          <div class="form-row">
            <div class="item-tit">은행명</div>
            <div class="item-desc">
              <div class="form-text-field">KANBDKF BANK</div>
            </div>
          </div>
          <div class="form-row">
            <div class="item-tit">지점명</div>
            <div class="item-desc">
              <div class="form-text-field">KANBDKF BANK LTD</div>
            </div>
          </div>
        </div>
        <strong class="info-question">입력하신 계좌와 지점명이 맞습니까?</strong>
      </template>
      <template #footer>
        <button class="btn bottom negative">아니오</button>
        <button class="btn bottom positive">예</button>
      </template>
    </action-sheet>
    <popup :opened.sync="opendPopup" :use-footer="true" :all-scroll="true" :btn-area-padding="true" title="MPAY-02-01-18-16">
      <template #content>
        <article class="contents">
          <div class="tabs --type3" id="tabs">
            <button
              v-for="(tab, index) in tabs"
              class="tab-button"
              :class="[{ active: tabs == vtnTabs ? currentTab === 1 : currentTab === index }, { disabled: tabs == vtnTabs }]"
              @click="tabClick(index)"
              :key="index"
              v-html="$t(tab)"
            ></button>
          </div>
          <div v-show="currentTab == 0">
            <!-- NAPAS -->
            <!-- <div class="form nomargin mtop-12">
              <div class="form-check-group --type3">
                <div class="form-row" v-for="(data, i) in localBankList" :key="i">
                  <div class="form-check">
                    <input
                      type="radio"
                      name="choicetype1"
                      :id="`choicetype1${i}`"
                      class="form-check-input"
                      :value="i"
                      v-model="selected"
                      @click="radioSelect(data)"
                    />
                    <label :for="`choicetype1${i}`" class="form-check-label">
                      <div class="bank-name">{{ $t(data.data) }}</div>
                      <span class="account">{{ data.value }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>-->
            <div class="form nomargin-bottom mtop-24">
              <div class="form-row">
                <div class="item-tit">{{ $t(/*은행명 또는 은행코드*/ "MPAY-02-01-18-07") }}</div>
                <div class="item-desc">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input-text id="searchWord2" :value.sync="searchWord2" placeholder="MDEP-01-01-04-16" alphaNumOnly toLowerCase :maxByte="40" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row nomargin-bottom">
                <div class="btn-area">
                  <button class="btn lg inline nomargin-bottom" @click="napasInq()">{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
            <template v-if="RBF0408W40.response.totalLineCnt > 0 && searchFlag == true">
              <account-List :breakdownList="false" :accountList="true">
                <template #total-count>
                  <strong class="total-count">{{ /*합계*/ $t("MPRS-02-02-01-07") }} : {{ RBF0408W40.response.totalLineCnt }}</strong>
                </template>
                <template #account-list>
                  <div v-for="(data, i) in RBF0408W40.response.grid" :key="i">
                    <div class="box-white -type4">
                      <div class="header" @click="napasClick(data)">
                        <div class="title">
                          {{ data.bnkEngName }}
                          <i class="icon icon-arrow-m-right" />
                        </div>
                        <div class="desc">
                          <div class="account">{{ data.ovsesSendBnkNo }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </account-List>
            </template>
            <template v-else>
              <div class="empty">
                <div class="empty-img">
                  <i class="icon icon-opt-no" />
                </div>
                <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
              </div>
            </template>
          </div>
          <div v-show="currentTab == 1">
            <!-- CITAD -->
            <div class="form nomargin-bottom mtop-24">
              <div class="form-row">
                <div class="item-tit">{{ $t(/*은행명 또는 은행코드*/ "MPAY-02-01-18-07") }}</div>
                <div class="item-desc">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input-text id="searchWord" :value.sync="searchWord" placeholder="MDEP-01-01-04-16" alphaNumOnly toLowerCase :maxByte="40" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row nomargin-bottom">
                <div class="btn-area">
                  <button class="btn lg inline nomargin-bottom" @click="citadInq()">{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
            <template v-if="!_.isEmpty(RBF0408F40.response.result) && searchFlag == true">
              <account-List :breakdownList="false" :accountList="true">
                <template #total-count>
                  <strong class="total-count">{{ /*합계*/ $t("MPRS-02-02-01-07") }} : {{ RBF0408F40.response.result.length }}</strong>
                </template>
                <template #account-list>
                  <div v-for="(data, i) in RBF0408F40.response.result" :key="i">
                    <div class="box-white -type4">
                      <div class="header" @click="citadClick(data)">
                        <div class="title">
                          {{ data.bnkNameCtnt }}
                          <i class="icon icon-arrow-m-right" />
                        </div>
                        <div class="desc">
                          <div class="account">{{ data.instiCdNo }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </account-List>
            </template>
            <template v-else-if="_.isEmpty(RBF0408F40.response.result) && searchFlag == true">
              <div class="empty">
                <div class="empty-img">
                  <i class="icon icon-opt-no" />
                </div>
                <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
              </div>
            </template>
            <template v-else></template>
            <div class="notice notice-box--type">
              <div class="notice-tit arrow">
                <p class="bullet">{{ /*유의사항*/ $t("MCOP-01-01-07-17") }}</p>
                <i class="icon icon-dropdown-m-arrow" @click="toggleShow" :class="{ rotate: show }" />
              </div>
              <div class="notice-cont" v-if="show">
                <ul class="ulist bar">
                  <li>{{ $t("MPAY-02-01-18-11") }}</li>
                  <li>{{ $t("MPAY-02-01-18-12") }}</li>
                  <li>{{ $t("MPAY-02-01-18-10") }}</li>
                </ul>
              </div>
            </div>
          </div>
        </article>
      </template>
      <template #footer>
        <button class="btn md gray" @click="popupClose()">{{ /*닫기*/ $t("MPRS-02-02-03-02") }}</button>
        <button class="btn md normal" @click="use()" :class="changeClass()">{{ /*사용*/ $t("MFXD-01-01-11-09") }}</button>
      </template>
    </popup>
    <action-sheet :opened.sync="noticeOpen" :actionHeader="true" :actionFooter="true" :useTopBorder="true" :title="/*유의사항*/ $t('MCOP-01-01-07-17')" class="action-sheet">
      <template #content>
        <ul class="ulist ulist-type--bullet">
          <li>{{ $t("MPAY-02-01-18-08") }}</li>
          <li v-html="$t('MPAY-02-01-18-09')"></li>
          <li>{{ $t("MPAY-02-01-18-10") }}</li>
        </ul>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="confirm()">{{ /*확인*/ $t("MCOM-0000003") }}</button>
      </template>
    </action-sheet>
    <action-sheet :opened.sync="notFoundOpen" :actionHeader="true" :actionFooter="true" :useTopBorder="true" :title="/*예금주 확인*/ $t('MPAY-02-01-18-14')">
      <template #content>
        <strong class="info-question nomargin-top">{{ $t("MPAY-02-01-18-13") }}</strong>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="notFoundOpen = !notFoundOpen">{{ /*확인*/ $t("MCOM-0000003") }}</button>
      </template>
    </action-sheet>
    <action-sheet :opened.sync="depositInfo" :actionHeader="true" :actionFooter="true" :useTopBorder="true" :title="/*입금정보 확인*/ $t('MPAY-02-01-18-15')">
      <template #content>
        <div class="form-confirm">
          <div class="form-row">
            <div class="item-tit">{{ /*은행명*/ $t("MPRS-02-02-02-05") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ napasBnkName }}</div>
            </div>
          </div>
          <template v-if="citadBnkYn">
            <div class="form-row">
              <div class="item-tit">{{ /*지점명*/ $t("MPRS-02-02-02-06") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ lcalBnkBrnEngName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*통화*/ $t("MINQ-01-01-06-08") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ citadCncycd }}</div>
              </div>
            </div>
          </template>
          <template v-if="recvCardAcc == '2'">
            <div class="form-row">
              <div class="item-tit">{{ /*입금 계좌번호*/ $t("MPRS-02-02-16-02") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ inquryAcno }}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="form-row">
              <div class="item-tit">{{ /*카드번호*/ $t("MPAY-02-01-18-03") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ card1 }}-{{ card2 }}-{{ card3 }}-{{ card4 }}</div>
              </div>
            </div>
          </template>
          <div class="form-row">
            <div class="item-tit">{{ /*예금주명*/ $t("MPAY-02-01-24-05") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ mnrcvDpstrName }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="item-tit">{{ /*계좌별명*/ $t("MPRS-02-02-19-07") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ inquryAcnAls }}</div>
            </div>
          </div>
        </div>
        <strong class="info-question">{{ /*입력하신 계좌를 등록하시겠습니까?*/ $t("MPAY-02-01-18-18") }}</strong>
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="closeSheet()">{{ /*아니오*/ $t("MCOM-0000005") }}</button>
        <button class="btn bottom positive" @click="regAcn()" :class="mnrcvDpstrName == '' ? 'disabled' : ''">{{ /*예*/ $t("MCOM-0000006") }}</button>
      </template>
    </action-sheet>
    <div class="btn-area--full fixed">
      <button class="btn md gray" @click="prev()">{{ $t("MPRS-02-01-04-05") /** 뒤로*/ }}</button>
      <button class="btn md normal" @click="next()" :class="prgsYN">{{ /*다음*/ $t("MOTP-01-05-10-08") }}</button>
    </div>
  </section>
</template>
<style type="scss" scoped></style>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import AccountList from "@/components/page/customer/account.vue";

export default {
  name: "napasManagePayees",
  computed: {
    ...mapFields(["sessionInfo", "addtlInfo"]),
    ...mapGetters(["isUserOtpDstcd"]),
    mnrcvDpstrNameData: {
      get() {
        return this.mnrcvDpstrName;
      },
      set(value) {
        this.mnrcvDpstrName = value;
        this.validPrgs();
      },
    },
  },
  components: {
    AccountList,
  },
  props: {
    usePage: {
      type: String,
    },
    cncycd: {
      type: String,
      required: true,
    },
    drowAcnInfo: {
      type: Object,
      // required: true,
    },
  },
  watch: {
    inquryAcno: function() {
      this.validPrgs();
    },
    inquryAcnAls: function() {
      this.validPrgs();
    },
    napasBnkName: function() {
      this.validPrgs();
    },
    card1: function() {
      this.validPrgs();
    },
    card2: function() {
      this.validPrgs();
    },
    card3: function() {
      this.validPrgs();
    },
    card4: function() {
      this.validPrgs();
    },
  },
  data() {
    return {
      type: "",
      show: false,
      searchFlag: false,
      type1: false,
      //계정계와 약속한 데이터로 value값 변경하면 안됨
      recvDstCd: [
        { value: "2", text: "MPRS-02-02-06-07" },
        { value: "1", text: "MPAY-02-01-18-03" },
      ],
      sendCardAcc: "2", //송금카드계좌구분
      inquryAcno: "",
      inquryAcnAls: "",
      searchWord: "",
      searchWord2: "",
      card1: undefined,
      card2: undefined,
      card3: undefined,
      card4: undefined,
      currentTab: 0,
      napasTabs: [this.$t("MPAY-02-01-18-17"), this.$t("MPAY-02-01-18-06")],
      vtnTabs: [this.$t("MPAY-02-01-18-06")],
      tabs: [],
      opendPopup: false,
      RBF04INA41: {
        request: {},
        response: {},
      },
      RBF0408F40: {
        request: {},
        response: {},
      },
      RBF0408W40: {
        request: {},
        response: {},
      },
      RBF0600C60: {
        request: {},
        response: {},
      },
      napasBnkNo: "",
      napasBnkName: "",
      tmpNapasBnkNo: "",
      tmpNapasBnkName: "",
      selected: 0,
      noticeOpen: false,
      notFoundOpen: false,
      mnrcvDpstrName: "",
      recvCardAcc: "2",
      depositInfo: false,
      RBF04INA40: {
        request: {},
        response: {},
      },
      cardNo: "",
      prgsYN: "disabled",
      brncoOtrbnkRmtancMdiaDstcd: "",
      mnrcvInfo: {},
      ovsesSendBnkNo: "",
      citadBnkYn: false,
      lcalBnkBrnEngName: "",
      optionList: [
        //베트남 타행이체 통화코드(USD, VND)
        {
          text: "VND",
          checked: false,
          value: "VND",
        },
        {
          text: "USD",
          checked: false,
          value: "USD",
        },
      ],
      citadCncycd: "",
    };
  },
  mounted() {
    this.type = this.$route.params.type;
    // if (this.addtlInfo.includes(this.$config.ALLOW_MENU_NAPAS)) {
    //타행이체 화면일 경우 출금계좌의 통화코드와 동일하게 자동 셋팅
    if (!"02|03".includes(this.isUserOtpDstcd) && this.$route.params.type != "manage" && this.drowAcnInfo.cncycd == this.$config.CNCYCD_USD) {
      this.tabs = this.vtnTabs;
      this.currentTab = 1;
      this.$refs.selectedCncycd.setValue(this.drowAcnInfo.cncycd);
      this.citadBnkYn = true;
    } else {
      this.tabs = this.napasTabs;
    }
    // } else {
    //   this.tabs = this.vtnTabs;
    //   this.currentTab = 1;
    //   //타행이체 화면일 경우 출금계좌의 통화코드와 동일하게 자동 셋팅
    //   if (this.$route.params.type != "manage") {
    //     this.$refs.selectedCncycd.setValue(this.drowAcnInfo.cncycd);
    //     this.citadBnkYn = true;
    //   }
    // }

    if ("02|03".includes(this.isUserOtpDstcd)) {
      if (this.$route.params.type != "manage" && this.drowAcnInfo.cncycd == this.$config.CNCYCD_USD) {
        this.tabs = this.vtnTabs;
        this.currentTab = 1;
        this.$refs.selectedCncycd.setValue(this.drowAcnInfo.cncycd);
        this.citadBnkYn = true;
      } else {
        this.tabs = this.napasTabs;
      }
    } else {
      this.tabs = this.vtnTabs;
      this.currentTab = 1;
      this.$refs.selectedCncycd.setValue(this.drowAcnInfo.cncycd);
      this.citadBnkYn = true;
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    changeClass() {
      if (this.tmpNapasBnkNo == "") {
        return "disabled";
      } else {
        return "";
      }
    },
    autoFocus1() {
      if (!_.isEmpty(this.card1)) {
        if (this.card1.length == 4) {
          document.getElementById("card2").focus();
        }
      }
    },
    autoFocus2() {
      if (!_.isEmpty(this.card2)) {
        if (this.card2.length == 4) {
          document.getElementById("card3").focus();
        }
      }
    },
    autoFocus3() {
      if (!_.isEmpty(this.card3)) {
        if (this.card3.length == 4 && !_.isEmpty(this.card3)) {
          document.getElementById("card4").focus();
        }
      }
    },
    validPrgs() {
      if (this.type == "manage") {
        if (this.$refs.inquryAcno != undefined || this.$refs.inquryAcnAls != undefined) {
          if (this.citadBnkYn) {
            this.prgsYN =
              this.$refs.inquryAcno.$v.$invalid ||
              this.$refs.inquryAcnAls.$v.$invalid ||
              this.napasBnkName == "" ||
              this.$refs.dpstrName.$v.$invalid ||
              this.$refs.selectedCncycd.$v.$invalid
                ? "disabled"
                : "";
          } else {
            this.prgsYN = this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.napasBnkName == "" ? "disabled" : "";
          }
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        } else {
          this.prgsYN = "";
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        }
      } else {
        //타행이체 화면에서 CITAD 선택일 때
        if (this.citadBnkYn) {
          this.prgsYN = this.$refs.inquryAcno.$v.$invalid || this.napasBnkName == "" || this.$refs.dpstrName.$v.$invalid ? "disabled" : "";
        } else if (this.recvCardAcc == "2") {
          if (this.$refs.inquryAcno != undefined) {
            this.prgsYN = this.$refs.inquryAcno.$v.$invalid || this.napasBnkName == "" ? "disabled" : "";
          } else {
            this.prgsYN = "";
          }
        } else {
          if (
            // this.$refs.bnkEngName != undefined &&
            this.$refs.card1 != undefined &&
            this.$refs.card2 != undefined &&
            this.$refs.card3 != undefined &&
            this.$refs.card4 != undefined
          ) {
            this.prgsYN =
              this.card1 != undefined &&
              this.card2 != undefined &&
              this.card3 != undefined &&
              this.card4 != undefined &&
              this.card1.length == 4 &&
              this.card2.length == 4 &&
              this.card3.length == 4 &&
              this.card4.length == 4
                ? ""
                : "disabled";
          } else {
            this.prgsYN = "";
          }
        }
        this.$EventBus.$emit("vtnRegister", this.prgsYN);
      }
    },
    RBF04INA41Call() {
      this.$post("/transfer/otrbnk/NapasCardNoInquiry", this.RBF04INA41.request, this.RBF04INA41Suc);
    },
    RBF04INA41Suc(res) {
      let tempArry = [];
      this.RBF04INA41.response = res.outItem;
      for (const data of this.RBF04INA41.response.dataGrid) {
        tempArry.push({ text: data.cardNo + " (" + data.acno + ")", value: data.cardNo, data: data.acno });
      }
      //this.$refs.withdrawalInfo.cardNumList = tempArry;
    },
    /**
     * 현지은행목록조회
     */
    RBF0408W40Call() {
      if (this.recvCardAcc == "1") {
        this.ovsesSendBnkNo = "";
        this.ovsesSendBnkNo = this.ovsesSendBnkNo.concat(this.card1, this.card2.substr(0, 2));
      }
      this.RBF0408W40.request = {
        dmndPageNo: 1,
        pageLineCnt: 1000,
        tranDstCd: "NPBNK",
        inquryBnkCtnt: this.searchWord2,
        ovsesSendBnkNo: this.recvCardAcc == "2" ? "" : this.ovsesSendBnkNo,
      };
      this.$post("/customer/acn/LocalBnkListInquiry", this.RBF0408W40.request, this.RBF0408W40Suc);
    },
    RBF0408W40Suc(res) {
      this.RBF0408W40.response = res.outItem; //ovsesSendBnkRefNo : bnkEngName
      if (this.RBF0408W40.response.gridRowCnt > 0) {
        // let tempArry = [];
        // for (const data of this.RBF0408W40.response.grid) {
        //   tempArry.push({ text: data.ovsesSendBnkNo + " (" + data.bnkEngName + ")", value: data.ovsesSendBnkNo, data: data.bnkEngName });
        // }
        // this.localBankList = tempArry;

        if (this.recvCardAcc == "1") {
          this.napasBnkName = this.RBF0408W40.response.grid[0].bnkEngName;
          this.napasBnkNo = this.RBF0408W40.response.grid[0].ovsesSendBnkNo;
          this.RBF04INA40Call();
          // } else {
          //   this.napasClick(this.localBankList[this.selected]);
          // }
        }
        // else {
        //   this.notFoundOpen = true;
      }
    },
    citadInq() {
      this.show = false;
      this.searchFlag = true;
      this.RBF0408F40Call();
    },
    napasInq() {
      this.show = false;
      this.searchFlag = true;
      this.RBF0408W40Call();
    },
    tabClick(index) {
      if (this.tabs == this.vtnTabs) {
        return;
      }
      this.currentTab = index;
      this.tmpNapasBnkNo = "";
      this.tmpNapasBnkName = "";
      // if (index == 0) {
      //   this.napasClick(this.localBankList[this.selected]);
      // }
    },
    /**
     * CITAD기관정보조회
     */
    RBF0408F40Call() {
      this.RBF0408F40.request = {
        inquryBnkCtnt: this.searchWord,
      };
      this.$post("/customer/acn/CitadBnkListInquiry", this.RBF0408F40.request, this.RBF0408F40Suc);
    },
    RBF0408F40Suc(res) {
      this.RBF0408F40.response = res.outItem;
    },
    openPopup() {
      this.opendPopup = true;
      this.show = true;
      this.searchFlag = false;
      this.searchWord = "";
      this.searchWord2 = "";
      this.tmpNapasBnkNo = "";
      this.tmpNapasBnkName = "";
      if (this.currentTab == 0) {
        this.RBF0408W40Call();
      }
      this.citadInq();
    },
    napasClick(data) {
      this.tmpNapasBnkNo = data.ovsesSendBnkNo;
      this.tmpNapasBnkName = data.bnkEngName;
    },
    citadClick(data) {
      this.tmpNapasBnkNo = data.instiCdNo;
      this.tmpNapasBnkName = data.bnkNameCtnt;
    },
    use() {
      this.napasBnkNo = this.tmpNapasBnkNo;
      this.napasBnkName = this.tmpNapasBnkName;
      if (this.currentTab == 0) {
        this.noticeOpen = true;
      } else {
        this.confirm();
      }
    },
    popupClose() {
      this.opendPopup = false;
    },
    RBF04INA40Call() {
      // this.drowAcnInfo = {
      //   sendCardAcc: "2",
      //   drwotAcnAls: "test",
      //   drwotCardNo: "",
      //   drwotAcno: "810001100000318",
      //   drwotSerno: "1",
      // };
      if (_.isEmpty(this.drowAcnInfo)) {
        this.RBF04INA40.request = {
          sendCardAcc: "2",
          drwotCardNo: "", // this.drowAcnInfo.sendCardAcc == "1" ? this.drowAcnInfo.drwotCardNo : "",
          drwotAcno: this.sessionInfo.userInfo.dataGrid[0].drwotAcno, //출금계좌번호
          drwotAcnAls: this.sessionInfo.userInfo.dataGrid[0].drwotAcnAls, //출금계좌별명,
          drwotCncycd: this.sessionInfo.userInfo.dataGrid[0].drwotCncycd, //출금통화코드,
          drwotSerno: this.sessionInfo.userInfo.dataGrid[0].drwotSerno, //출금계좌일련번호
          recvCardAcc: this.recvCardAcc,
          mnrcvCardNo: this.recvCardAcc == "1" ? this.cardNo : "",
          mnrcvAcno: this.recvCardAcc == "1" ? "" : this.inquryAcno,
          rcevnBnkNo: this.napasBnkNo,
          mnrcvOthrBnkName: this.napasBnkName,
          mnrcvCncycd: "VND",
        };
      } else {
        this.RBF04INA40.request = {
          sendCardAcc: "2",
          drwotCardNo: "", // this.drowAcnInfo.sendCardAcc == "1" ? this.drowAcnInfo.drwotCardNo : "",
          drwotAcno: this.drowAcnInfo.sendCardAcc == "1" ? "" : this.drowAcnInfo.acno, //출금계좌번호
          drwotAcnAls: this.drowAcnInfo.acnoAls, //출금계좌별명,
          drwotCncycd: this.cncycd, //출금통화코드,
          drwotSerno: "", //this.drowAcnInfo.drwotSerno, //출금계좌일련번호
          recvCardAcc: this.recvCardAcc,
          mnrcvCardNo: this.recvCardAcc == "1" ? this.cardNo : "",
          mnrcvAcno: this.recvCardAcc == "1" ? "" : this.inquryAcno,
          rcevnBnkNo: this.napasBnkNo,
          mnrcvOthrBnkName: this.napasBnkName,
          mnrcvCncycd: "VND",
        };
      }
      this.$post("/transfer/otrbnk/NapasDraweNameInquiry", this.RBF04INA40.request, this.RBF04INA40Suc);
    },
    RBF04INA40Suc(res) {
      this.RBF04INA40.response = res.outItem;
      this.mnrcvDpstrName = this.RBF04INA40.response.mnrcvDpstrName;
      if (this.mnrcvDpstrName == "") {
        this.notFoundOpen = true;
      } else {
        if (this.napasBnkName == "") {
          this.napasBnkName = this.RBF04INA40.response.mnrcvOthrBnkName;
        }

        this.depositInfo = true;
      }
    },
    confirm() {
      if (this.currentTab == 0) {
        this.citadBnkYn = false;
        this.brncoOtrbnkRmtancMdiaDstcd = "03";
      } else {
        this.citadBnkYn = true;
        this.brncoOtrbnkRmtancMdiaDstcd = "";
        if (this.$route.params.type != "manage") {
          this.$refs.selectedCncycd.setValue(this.drowAcnInfo.cncycd);
        }
      }
      this.noticeOpen = false;
      this.opendPopup = false;
    },
    next() {
      this.cardNo = "";
      this.cardNo = this.cardNo.concat(this.card1, this.card2, this.card3, this.card4);
      if (this.type == "manage") {
        if (this.citadBnkYn) {
          this.depositInfo = true;
        } else {
          this.RBF04INA40Call();
        }
      } else {
        if (this.recvCardAcc == "2") {
          this.RBF04INA40Call();
        } else {
          this.RBF0408W40Call();
        }
      }

      // if (this.type == "manage") {
      //   this.RBF04INA40Call();
      // }
    },
    prev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    closeSheet() {
      if (this.recvCardAcc == "1") {
        this.napasBnkName = "";
        this.napasBnkNo = "";
      }
      this.depositInfo = false;
    },
    regAcn() {
      if (!_.isEmpty(this.drowAcnInfo)) {
        this.$parent.$parent.$parent.checkAcno();
      } else {
        this.RBF0600C60Call();
      }
    },

    RBF0600C60Call() {
      this.RBF0600C60.request = {
        dmndPageNo: "00000",
        pageLineCnt: "00000",
        gridRowCnt: "00001",
        inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
        deviceType: "mobile",
        inDataGrid: [
          {
            inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
            inquryAcno: this.inquryAcno, // 계좌번호
            inqurySerno: "1", // 일련번호
            inquryBrncoEcrypPwd: "", // 계좌비밀번호
            inquryAcnAls: this.inquryAcnAls, // 계좌별명
            inquryDpstrName: this.mnrcvDpstrName, // 예금주명
            inquryOthrBnkName: this.napasBnkName, // 타은행명
            inquryBrnName: this.lcalBnkBrnEngName, // 부점명
            inquryCncycd: this.citadBnkYn ? this.citadCncycd : this.cncycd, //통화코드
            inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
            inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
            rcevnBnkIfscCode: this.napasBnkNo,
            draweAcitmDstcd: this.recvCardAcc == "1" ? "02" : "01",
            brncoOtrbnkRmtancMdiaDstcd: this.brncoOtrbnkRmtancMdiaDstcd,
          },
        ],
      };

      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        this.RBF0600C60.request, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
      );
    },
    /* API_RBF0600C60 호출 성공 */
    RBF0600C60Suc(res) {
      this.RBF0600C60.response = res.outItem;
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    setInfo() {
      this.cardNo = "";
      this.cardNo = this.cardNo.concat(this.card1, this.card2, this.card3, this.card4);
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.recvCardAcc == "2" ? this.inquryAcno : "",
        mnrcvCardNo: this.recvCardAcc == "1" ? this.cardNo : "",
        mnrcvCncycd: this.drowAcnInfo.cncycd == this.$config.CNCYCD_USD ? this.$config.CNCYCD_USD : this.cncycd, //출금계좌가 USD일 경우(CITAD거래), 입금계좌 통화도 USD로 셋팅
        mnrcvDpstrName: this.mnrcvDpstrName,
        // mnrcvOthrBnkName: this.lcalBnkBrnEngName,
        mnrcvOthrBnkName: this.napasBnkName,
        mnrcvSerno: "",
        rcevnBnkIfscCode: this.napasBnkNo,
        mnrcvBrnName: this.citadBnkYn ? this.lcalBnkBrnEngName : "",
        tranDstCd: this.currentTab == "0" ? "03" : "", //napas 0, citad 1
        recvCardAcc: this.recvCardAcc,
      };
      return this.mnrcvInfo;
    },
  },
};
</script>
